import React from 'react';

export default function ConfirmDialog({ open, title, message, onConfirm, onCancel }) {
  if (!open) return null;

  return (
    <div className="ednl-dialog-overlay" onClick={onCancel}>
      <div className="ednl-dialog" onClick={(e) => e.stopPropagation()}>
        <h3 className="ednl-dialog__title">{title || 'Confirm'}</h3>
        <p className="ednl-dialog__message">{message || 'Are you sure?'}</p>
        <div className="ednl-dialog__actions">
          <button className="ednl-btn ednl-btn--secondary" onClick={onCancel}>Cancel</button>
          <button className="ednl-btn ednl-btn--danger" onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
